module.exports = __webpack_public_path__ + "img/banner.9eded15.jpg";